/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap.js");
require('iframe-resizer');

/**
 * Loads a global event dispatcher
 * All global events are dispatched here
 */
require("./events.js");

/**
 * Loads a global event dispatcher
 * All global events are dispatched here
 */
require("./events_tracker.js");

/**
 * Include all Vue directives for the application
 */
require("./directives/confirmation.js");
require("./directives/rowaction");
require("./directives/tab-inputs.js");

/**
 * Include Vue components for the application
 * Registered by project
 */
require("./components/compass.js");
require("./components/tracker.js");

/**
 * Include non vue javascript
 *require("./components/table-action.js");
 */

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// user management stuff
import VModal from 'vue-js-modal'
import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import {i18n, loadLanguageAsync} from "./i18n";

Vue.use(VModal, { componentName: "vuejs-modal", dialog: true });
Vue.use(VuejsDialog);

// user management
Vue.component("user-management-list", () => import("./components/users/UserManagementList.vue"));
Vue.component("school-membership-list", () => import("./components/schoolmemberships/SchoolMembershipList.vue"));
Vue.component("register-user-form", () => import("./components/compass/RegisterUserForm.vue"));

// Schools
Vue.component("school-management-list", () => import("./components/admin/schools/SchoolManagementList.vue"));
Vue.component("school-details", () => import("./components/admin/schools/SchoolDetails.vue"));
Vue.component("school-membership-table", () => import("./components/admin/schools/SchoolMembershipTable.vue"));

// Alpha Issues
Vue.component("alpha-issues", () => import("./components/admin/alphaissues/AlphaIssuesGlobal.vue"));

// leps
Vue.component("lep-management-list", () => import("./components/admin/leps/LepManagementList.vue"));
Vue.component("lep-user-list", () => import("./components/admin/leps/users/LepUserList.vue"));
Vue.component("region-user-list", () => import("./components/admin/leps/users/RegionUserList.vue"));
Vue.component("area-user-list", () => import("./components/admin/leps/users/AreaUserList.vue"));
Vue.component("hub-user-list", () => import("./components/admin/leps/users/HubUserList.vue"));
Vue.component("lep-entity-name-edit", () => import("./components/admin/leps/LepEntityNameEdit.vue"));
Vue.component("lep-entity-relationship-edit", () => import("./components/admin/leps/LepEntityRelationshipEdit.vue"));
Vue.component("lep-school-list", () => import("./components/admin/leps/schools/LepSchoolList.vue"));
Vue.component("hub-school-list", () => import("./components/admin/leps/schools/HubSchoolList.vue"));
Vue.component("region-school-list", () => import("./components/admin/leps/schools/RegionSchoolList.vue"));
Vue.component("area-school-list", () => import("./components/admin/leps/schools/AreaSchoolList.vue"));

Vue.component("passportClients", () => import("./components/passport/Clients.vue"));
Vue.component(
  "passportAuthorizedClients",
  () => import("./components/passport/AuthorizedClients.vue")
);
Vue.component(
  "passportPersonalAccessTokens",
  () => import("./components/passport/PersonalAccessTokens.vue")
);

window.app = new Vue({
  el: "#app",
  data: {
    hidePopup: false,
    showModal: false,
    showActions: true
  },
  methods: {
    printPage(url) {
      let printWindow = window.open(url);
      printWindow.focus();
      setTimeout(function(){printWindow.print()}, 500);
    },
    scrollToError() {
      let error = this.$el.querySelector(".field-error");
      if (error) {
        window.scrollTo(0, error.getBoundingClientRect().top - 350);
      }
    }
  },
  mounted() {
    loadLanguageAsync(document.documentElement.lang);
    this.scrollToError();
  },
  i18n
});
